import Vue from 'vue';
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/zh-CN';
import './common/less/reset.less';
import './common/less/animate.css';
import './common/less/global.less';
import './common/fonts/iconfont.css';
import {tool} from './common/js/tool.js';
import store from './vuex/index.js';
Vue.config.productionTip = false;

import PageBase from './containers/page/base.vue';
import Tab from './components/header/tab.vue';
import Nodata from './components/nodata/nodata.vue';
import Header from './components/header/header.vue';
import panePersonInfo from './components/pane-person-info.vue';
import warningSearch from './components/warning-search.vue';
import trackSearch from './components/track-search.vue';
import InOutSearch from './components/in-out-search.vue';
import ShipMap from './components/ship-map.vue';
import SvgPolygon from './components/svg-polygon.vue';
import SvgLine from './components/svg-line.vue';

Vue.use(ElementUI, {locale});
Vue.component('v-pagebase', PageBase);
Vue.component('v-tab', Tab);
Vue.component('v-nodata', Nodata);
Vue.component('v-header', Header);
Vue.component('v-pane-person-info', panePersonInfo);
Vue.component('v-warning-search', warningSearch);
Vue.component('v-track-search', trackSearch);
Vue.component('v-in-out-search', InOutSearch);
Vue.component('v-ship-map', ShipMap);
Vue.component('v-svg-polygon', SvgPolygon);
Vue.component('v-svg-line', SvgLine);

import echarts from 'echarts';
Vue.prototype.$echarts = echarts;

router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) {
    // console.log(to.name);
    // console.log(tool.getCookie('urls'));
    if (tool.getCookie('urls')) {
      let b = JSON.parse(tool.getCookie('urls'));
      if (b.indexOf(to.name) > -1) {
        next();
      } else {
        console.log(to.name);
        tool.message('你没有访问该页面的权限', 'error');
      }
    } else {
      tool.message('你没有访问该页面的权限', 'error');
      console.log(to.name);
      // next({
      //   path: '/hold',
      //   query: {
      //     redirect: to.fullPath
      //   }
      // })
    }
    return;
    alert(to.name);

    if (tool.getCookie('token')) {
      next();
    } else {
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      })
    }
  } else {
    next();
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
